import React, { useEffect, useState } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink, Row } from "reactstrap";
import SermonCollections from "./sermon-collections";
import AudioBooks from "./audiobooks";
import { getActiveTab } from "../../../common/util";
import { Helmet } from "react-helmet";
import { CHAPEL_LIBRARY } from "../../../common/constants";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import "../styles/style.css";

const AudioVideo = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [activeTab, setActiveTab] = useState(null);

  function getTabs() {
    const tabs = {
      audiobooks: {
        translationKey: "audiobooks",
        component: <AudioBooks {...props} />,
      },
      sermoncollections: {
        translationKey: "audio-sermon-collections",
        component: <SermonCollections {...props} />,
      },
    };
    return tabs;
  }

  function toggle(tab) {
    if (activeTab !== tab) {
      setActiveTab(tab);
      navigate(`/audio/${tab}`);
    }
  }

  function getNavItems(tabs) {
    return Object.keys(tabs).map((tab, i) => (
      <NavItem key={i}>
        <NavLink
          className={activeTab === tab ? "active" : ""}
          onClick={() => {
            toggle(tab);
          }}
        >
          <span>{t(tabs[tab].translationKey)}</span>
        </NavLink>
      </NavItem>
    ));
  }

  function getTabPanes(tabs) {
    return Object.keys(tabs).map((tab, i) => (
      <TabPane tabId={tab} key={i}>
        <Row>{tabs[tab].component}</Row>
      </TabPane>
    ));
  }

  const tabs = getTabs();

  useEffect(() => {
    if (!activeTab) {
      setActiveTab(getActiveTab(tabs));
    }
  }, [activeTab]);

  return (
    <div>
      <Helmet>
        <title>
          {t("audiobooks") + " & " + t("audio-sermon-collections")} -{" "}
          {CHAPEL_LIBRARY}
        </title>
        <meta
          name="description"
          content="Audiobooks in MP3. Sermons from Spurgeon, Al Martin, and others. Mt Zion Bible Church pulpit sermons in MP3 and video."
        />
      </Helmet>
      <div className="alert alert-success m-0 text-center">
        {t("audio-mzbc")}
        <a href="https://mtzionbiblechurch.org/sermons" target="_blank">
          MtZionBibleChurch.org
        </a>
      </div>
      <Nav tabs>{getNavItems(tabs)}</Nav>
      <TabContent className="text-justify" activeTab={activeTab}>
        {getTabPanes(tabs)}
      </TabContent>
    </div>
  );
};

export default AudioVideo;
